import React, { useEffect, useState, useRef } from "react"; // added useRef
import "../../Style/LandingPage/Explore.css";
import { Link } from "react-router-dom";
import axios from "axios";

const Explore = () => {
  const [top5HomeCategory, setTop5HomeCategory] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [visibleCards, setVisibleCards] = useState(5);
  const [categoryStats, setCategoryStats] = useState({});
  const [allTrips, setAllTrips] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const sliderRef = useRef(null); // ref for mobile slider

  // Adjust visible cards and track window width
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth <= 768) {
        setVisibleCards(6);
      } else {
        setVisibleCards(5);
      }
    };
    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch home categories
  const getSelectedHomeCategory = async () => {
    try {
      const res = await axios.get("/api/homecategory/get-home-category");
      setTop5HomeCategory(res.data.data[0]?.curatedCategory || []);
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch all categories
  const getAllCategory = async () => {
    try {
      const res = await axios.get("/api/category/get-all-category");
      setAllCategory(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch all trips
  const getAllTrips = async () => {
    try {
      const res = await axios.get("/api/trips/get-all-trips");
      setAllTrips(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // Compute stats per category
  useEffect(() => {
    if (!allTrips.length || !top5HomeCategory.length) return;

    const stats = {};
    top5HomeCategory.slice(0, visibleCards).forEach((categoryName) => {
      const filteredTrips = allTrips.filter((trip) =>
        trip.category?.some((cat) =>
          cat.toLowerCase().includes(categoryName.toLowerCase())
        )
      );

      let lowestPrice = Infinity;

      filteredTrips.forEach((trip) => {
        trip.costing
          ?.filter(
            (costBlock) =>
              costBlock.heading &&
              costBlock.heading.toLowerCase().includes("group departure")
          )
          ?.forEach((costBlock) => {
            costBlock.package?.forEach((pkg) => {
              const price = Number(pkg.price);
              if (!isNaN(price) && price > 0 && price < lowestPrice) {
                lowestPrice = price;
              }
            });
          });
      });

      stats[categoryName] = {
        totalTrips: filteredTrips.length,
        lowestPrice: isFinite(lowestPrice) ? lowestPrice : 0,
      };
    });

    setCategoryStats(stats);
  }, [allTrips, top5HomeCategory, visibleCards]);

  // Initial data fetch
  useEffect(() => {
    getSelectedHomeCategory();
    getAllCategory();
    getAllTrips();
  }, []);

  // Auto-scroll mobile slider
  useEffect(() => {
    if (windowWidth > 768) return; // only on mobile

    const slider = sliderRef.current;
    let scrollAmount = 0;

    const interval = setInterval(() => {
      if (!slider || !slider.firstChild) return;
      const cardWidth = slider.firstChild.offsetWidth + 16; // card width + gap
      scrollAmount += cardWidth;
      if (scrollAmount >= slider.scrollWidth) {
        scrollAmount = 0; // reset scroll
      }
      slider.scrollTo({ left: scrollAmount, behavior: "smooth" });
    }, 3000); // scroll every 3 seconds

    return () => clearInterval(interval);
  }, [top5HomeCategory, windowWidth]);

  return (
    <div
      className="explore-container Mon_font"
      style={{
        background:
          "linear-gradient(315deg, #bce4ff 0%, #f3c5ff 50%, #d6b8ff 100%)",    marginBottom: "60px",   // 👈 Add this

      }}
    >
      <h2 className="category__heading text-center">
        Embark on an Adventure to Discover the Coolest Destinations
      </h2>
      <div className="hr-line"></div>

      <div
        ref={sliderRef} // attach ref here for auto-scroll
        className={`explore__container Mon_font ${
          windowWidth <= 768 ? "mobile-slider" : ""
        }`}
      >
        {top5HomeCategory.slice(0, visibleCards).map((category) => {
          const data = allCategory.find((obj) => obj?.name === category);
          if (!data) return null;

          const stats = categoryStats[category] || {};
          const packageCount = stats.totalTrips || 0;
          const startingPrice = stats.lowestPrice || 0;

          return (
            <div key={category} className="explore__feature">
              <Link to={`/category/${category}`} className="card-link">
                <div className="card-image-wrapper">
                  <img src={data?.url} alt={category} />
                </div>

                <div className="card-details">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h3 className="trip-title" style={{ margin: 0 }}>
                      {category}
                    </h3>
                  </div>

                  <p
                    className="package-text"
                    style={{
                      margin: "8px 0",
                      padding: "6px 12px",
                      borderRadius: "12px",
                      backgroundColor: "#ff4d4d",
                      color: "white",
                      fontWeight: "500",
                      display: "inline-block",
                      textTransform: "none",
                    }}
                  >
                    {packageCount}+ Packages
                  </p>

                  <p className="trip-overview">
                    {data?.overview?.slice(0, 100) ||
                      "Explore the beauty, culture, and adventure this destination has to offer."}
                  </p>

                  <p
                    className="price-text"
                    style={{
                      backgroundColor: "#ffca00",
                      padding: "10px 20px",
                      borderRadius: "12px",
                      color: "black",
                    }}
                  >
                    Starting Price: ₹{startingPrice.toLocaleString()}
                  </p>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Explore;
